<template>
  <div class="m-0">
    <nav id="topNav" class="navbar navbar-expand-lg mx-3 m-2 top-nav sticky-top px-4">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img src="@/assets/images/eTender.png" alt="eTender Logo" />
        </a>

        <!-- Mobile Icons -->
        <div class="d-flex align-items-center justify-content-center d-lg-none">
          <ul class="navbar-nav flex-row align-items-center justify-content-center icons">
            <li class="nav-item">
              <a href="#" class="nav-link">
                <i class="fa-solid fa-fw fa-magnifying-glass text-white" style="font-size: 20px"></i>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white position-relative">
                <i class="fa-solid fa-bell fa-fw ms-2" style="font-size: 18px"></i>
                <span class="position-absolute translate-middle badge rounded-pill bg-issues"
                      style="top: 7px; right: -0.4rem; padding: 3px 5px; font-size: 9px">
                  2
                  <span class="visually-hidden">unread messages</span>
                </span>
              </a>
            </li>
            <li class="nav-item">
              <div class="dropstart">
                <a class="btn-sm nav-link d-flex align-items-center position-relative"
                   data-bs-toggle="dropdown" aria-expanded="false">
                  <img src="@/assets/images/profile.png" alt="Profile" class="ms-2 w-100" />
                  <i class="fa-solid fa-caret-down text-white ms-2"></i>
                </a>
                <ul class="dropdown-menu mt-5 profile-menu position-absolute top-0 end-0">
                  <li><router-link class="dropdown-item text-dark" to="/profile">Profile</router-link></li>
                  <li><a class="dropdown-item text-dark" @click.prevent="logOut">Log out</a></li>
                </ul>
              </div>
            </li>
          </ul>
          <button class="btn" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                  aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fa-solid fa-bars text-white fs-4"></i>
          </button>
        </div>

        <!-- Navigation Links -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-md-4 ms-0">
            <li class="nav-item">
              <router-link class="nav-link" :class="{ active: checkpath('/dashboard') }" to="/dashboard">Dashboard</router-link>
            </li>
            <li class="nav-item" v-if="user?.type">
              <router-link class="nav-link" :class="{ active: checkpath('/' + user.type + '/tender') }"
                           :to="'/' + user.type + '/tender'">Tenders</router-link>
            </li>
            <!--
            <li class="nav-item" v-if="user?.type">
              <router-link class="nav-link" :class="{ active: checkpath('/' + user.type + '/auctions') }"
                           :to="'/' + user.type + '/auctions'">Auctions</router-link>
            </li>
            -->
            <li class="nav-item" v-if="user?.type === 'buyer'">
              <router-link class="nav-link" :class="{ active: checkpath('/' + user.type + '/vendor') }"
                           :to="'/' + user.type + '/vendor'">Vendors</router-link>
            </li>
            <li class="nav-item" v-if="user?.type">
              <router-link class="nav-link"
                           :class="{ active: $route.path.includes('/' + user.type + '/resourcelibrary') }"
                           :to="'/' + user.type + '/resourcelibrary'">Resource Library</router-link>
            </li>
          </ul>
        </div>

        <!-- Desktop Right Side -->
        <ul class="navbar-nav align-items-center d-none d-lg-flex">
          <li class="nav-item mx-2 text-white">
            {{ user.name }} <span class="small text-white">({{ user.type.toUpperCase() }})</span>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white position-relative">
              <i class="fa-solid fa-bell fa-fw" style="font-size: 18px"></i>
              <span class="position-absolute translate-middle badge rounded-pill bg-issues"
                    style="top: 7px; right: -0.4rem; padding: 3px 5px; font-size: 9px">
                2
                <span class="visually-hidden">unread messages</span>
              </span>
            </a>
          </li>
          <li class="nav-item">
            <div class="dropstart">
              <a class="btn-sm nav-link d-flex align-items-center position-relative"
                 data-bs-toggle="dropdown" aria-expanded="false">
                <img src="@/assets/images/profile.png" alt="Profile" class="w-100" />
                <i class="fa-solid fa-caret-down text-white ms-2"></i>
              </a>
              <ul class="dropdown-menu mt-5 bg-dark position-absolute top-0 end-0">
                <li v-if="user?.type">
                  <router-link class="dropdown-item text-dark" :to="'/' + user.type + '/profile'">Profile</router-link>
                </li>
                <li>
                  <button class="dropdown-item text-dark" @click="logOut">Log Out</button>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>

    <main style="background: #f0f4f7">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  props: ["user"],
  methods: {
    checkpath(path) {
      return this.$route.path.includes(path);
    },
    logOut() {
      this.$router.push("/signin/buyer").then(() => {
        this.$store?.dispatch?.("auth/logout");
      });
    },
  },
};
</script>
